import { React, useEffect, useState } from "react";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";

import api from "../../services/api";
import PegaEvangelhoDia from "../../Utils/EvangelhoDoDia";
import PegaTextosBiblia from "../../Utils/TextosBiblia";
import { CopyToClipboard } from "react-copy-to-clipboard";

export default function Home() {
	const [bookList, setBookList] = useState([]);
	const [loadingBooks, setLoadingBooks] = useState(false);
	const [loadingEvangelho, setLoadingEvangelho] = useState(false);
	const [loadingTexto, setLoadingTexto] = useState(false);
	const [livro1, setLivro1] = useState(0);
	const [capitulo1, setCapitulo1] = useState("");
	const [versiculo1, setVersiculo1] = useState("");
	const [livro2, setLivro2] = useState(0);
	const [capitulo2, setCapitulo2] = useState("");
	const [versiculo2, setVersiculo2] = useState("");
	const [texto, setTexto] = useState("");

	useEffect(() => {
		if (loadingEvangelho) {
			PegaEvangelhoDia().then((returnValue) => {
				var aux = returnValue.split("#");
				setLivro1(aux[0]);
				setCapitulo1(aux[1]);
				if (aux[2].indexOf(",") > 0) {
					var auxHifen = aux[2].split("-");
					var auxVirgula = auxHifen[1].split(",");
					setVersiculo1(`${auxHifen[0]}-99`);
					setLivro2(aux[0]);
					setCapitulo2(auxVirgula[0]);
					setVersiculo2(`1-${auxVirgula[1].replace(/\D/g, "")}`);
				} else {
					setVersiculo1(aux[2]);
					setLivro2(0);
					setCapitulo2("");
					setVersiculo2("");
				}
				setLoadingEvangelho(false);
			});
		}
	}, [loadingEvangelho]);

	useEffect(() => {
		function validaCampos() {
			if (livro1 * 1 === 0 && livro2 * 1 === 0) {
				alert("É necessário escolher ao menos um livro!");
				return false;
			}
			if (capitulo1 === "" && capitulo2 === "") {
				alert("É necessário escolher ao menos um capítulo!");
				return false;
			}
			if (isNaN(capitulo1) || isNaN(capitulo2)) {
				alert("O capítulo deve ser valor numérico!");
				return false;
			}
			if (livro1 * 1 !== 0 && capitulo1 === "") {
				alert("É necessário escolher o capítulo do livro 1!");
				return false;
			}
			if (livro2 * 1 !== 0 && capitulo2 === "") {
				alert("É necessário escolher o capítulo do livro 2!");
				return false;
			}
			return true;
		}
		function retornaVersiculoFormatado(versiculos, maxVersiculo) {
			var versiculoFormatado = "";
			var auxVersiculo = versiculos.split("-");

			if (auxVersiculo.length > 1) {
				versiculoFormatado = ` ${auxVersiculo[0]}:${
					auxVersiculo[1] >= maxVersiculo ? maxVersiculo : auxVersiculo[1]
				}`;
			} else {
				versiculoFormatado = versiculos === "" ? "" : `:${versiculos}`;
			}

			return versiculoFormatado;
		}
		async function retornaTexto(api, livro, capitulo, versiculo) {
			var objVerses = await PegaTextosBiblia(api, livro, capitulo, versiculo);
			var versiculoFormatado = retornaVersiculoFormatado(
				versiculo,
				objVerses.maxVerse
			);

			return objVerses.texto
				.replace("[bookName]", objVerses.bookName)
				.replace("[verses]", versiculoFormatado);
		}
		async function loadText() {
			try {
				if (loadingTexto) {
					if (validaCampos()) {
						setTexto("");
						var texto = "";
						if (livro1 * 1 !== 0) {
							texto = `${await retornaTexto(
								api,
								livro1,
								capitulo1,
								versiculo1
							)}`;
						}
						if (livro2 * 1 !== 0) {
							texto = `${texto}
${await retornaTexto(api, livro2, capitulo2, versiculo2)}`;
						}

						setTexto(texto);
					}
				}
			} catch (error) {
				alert(error?.message);
			} finally {
				setLoadingTexto(false);
			}
		}

		loadText();
	}, [
		loadingTexto,
		livro1,
		livro2,
		capitulo1,
		capitulo2,
		versiculo1,
		versiculo2,
	]);

	const handleClickEvangelho = () => setLoadingEvangelho(true);
	const handleClickTexto = () => setLoadingTexto(true);

	useEffect(() => {
		if (loadingBooks) {
			return;
		}

		if (bookList.length > 0) return;

		setLoadingBooks(true);

		api.get("books").then((response) => {
			setBookList([...bookList, ...response.data]);
			setLoadingBooks(false);
		});
	}, [loadingBooks, bookList]);

	return (
		<div>
			<Container fluid>
				<Row>
					<Col>
						<p>
							Atualizado em <strong>24/07/2024 18:10</strong>
						</p>
						<p>
							O(s) versículo(s) pode ser omitido ou separado por "-" para
							intervalos. EX: 12-17;19;22-28
						</p>
					</Col>
				</Row>
				<Row>
					<Col>
						<Form>
							<Row className="align-items-center">
								<Col xs="auto">
									<Form.Control
										as="select"
										className="mb-2"
										id="livro1"
										placeholder="Livro"
										value={livro1}
										onChange={(e) => setLivro1(e.target.value)}
									>
										<option value="0">Livro</option>
										{bookList.map((list) => (
											<option key={list.id} value={list.id}>
												{list.name}
											</option>
										))}
									</Form.Control>
								</Col>
								<Col xs="auto">
									<Form.Control
										className="mb-2"
										id="capitulo1"
										placeholder="Capítulo"
										value={capitulo1}
										onChange={(e) => setCapitulo1(e.target.value)}
									/>
								</Col>
								<Col xs="auto">
									<Form.Control
										className="mb-2"
										id="versiculo1"
										placeholder="Versículo(s)"
										value={versiculo1}
										onChange={(e) => setVersiculo1(e.target.value)}
									/>
								</Col>
							</Row>
							<Row className="align-items-center">
								<Col>
									<hr></hr>
								</Col>
							</Row>
							<Row className="align-items-center">
								<Col xs="auto">
									<Form.Control
										as="select"
										className="mb-2"
										id="livro2"
										placeholder="Livro"
										value={livro2}
										onChange={(e) => setLivro2(e.target.value)}
									>
										<option value="0">Livro</option>
										{bookList.map((list) => (
											<option key={list.id} value={list.id}>
												{list.name}
											</option>
										))}
									</Form.Control>
								</Col>
								<Col xs="auto">
									<Form.Control
										className="mb-2"
										id="capitulo2"
										placeholder="Capítulo"
										value={capitulo2}
										onChange={(e) => setCapitulo2(e.target.value)}
									/>
								</Col>
								<Col xs="auto">
									<Form.Control
										className="mb-2"
										id="versiculo2"
										placeholder="Versículo(s)"
										value={versiculo2}
										onChange={(e) => setVersiculo2(e.target.value)}
									/>
								</Col>
							</Row>
							<Row className="align-items-center">
								<Col sm={2}>
									<Button
										variant="outline-primary"
										disabled={loadingEvangelho}
										onClick={!loadingEvangelho ? handleClickEvangelho : null}
									>
										{loadingEvangelho ? "Loading…" : "Evangelho do dia"}
									</Button>
								</Col>
								<Col sm={2}>
									<Button
										variant="outline-primary"
										disabled={loadingTexto}
										onClick={!loadingTexto ? handleClickTexto : null}
									>
										{loadingTexto ? "Loading…" : "Pega textos biblicos"}
									</Button>
								</Col>
								<Col sm={1}>
									<CopyToClipboard text={texto}>
										<Button
											variant="outline-primary"
											hidden={texto.length === 0}
										>
											Copiar texto
										</Button>
									</CopyToClipboard>
								</Col>
							</Row>
							<Row className="align-items-center">
								<Col sm={5}>
									<p></p>
									<Form.Control
										as="textarea"
										rows={10}
										className="mb-2"
										id="texto"
										value={texto}
										hidden={texto.length === 0}
										readOnly
									/>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
				<Row>
					<Col></Col>
				</Row>
			</Container>
		</div>
	);
}
